<template>
    <BasePanel 
        headline="lang_ERP_SHIPPING_CAPTION_SHIPPING_ROWS"
        :alvqa="alvqa"
        @clickOnPanel="hideInventories()"
    >   
        <template v-slot:panelContent>     
            <v-data-table
                class="baseInlineEditingDataTable"
                :headers="headers"
                :items="items"
                :items-per-page="990"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                :loading="disableShowInventoriesBtn"
            >
                <template v-slot:top>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col 
                            v-if="showImportExcelButton"
                            cols="3"
                        >
                            <BaseButton 
                                @click="importExcel"
                                label="lang_GENERAL_CAPTION_IMPORT_EXCEL"
                                block
                                :alvqa="alvqa + '-button-import-excel'"
                            />
                        </v-col>
                        <v-col 
                            v-if="$store.getters.getShippingDetailsAlvId !== 'ALV000000000SD'"
                            cols="3"
                        >
                            <BaseButton 
                                @click="fetchInventories()"
                                :label="showInventories ? 'lang_ERP_SHIPPING_ITEMS_HIDE_INVENTORIES' : 'lang_ERP_SHIPPING_ITEMS_SHOW_INVENTORIES'"
                                block
                                :disabled="disableShowInventoriesBtn"
                                :alvqa="alvqa + '-button-show-inventories'"
                            />
                        </v-col>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>
                <!-- Items -->
                <template v-slot:[`item.connectionObject`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-title'" class="ellipsis">
                        <BaseIcon  
                            :icon="$alvPlugin.getIconOfType(item.type)" 
                            :tooltipText="$alvPlugin.getIconTooltipText(item)"
                            :alvqa="alvqa + '-icon'"
                        />
                        {{ $alvPlugin.getTitle(item) }}
                        <!-- <BaseTooltip 
								:simpleText="$alvPlugin.getTitle(item)" 
							/> -->
                    </div>
                </template>

                <template v-slot:[`item.productId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-product-item-id'" class="ellipsis">
                        <BaseTooltip 
								:simpleText="$alvPlugin.getProductItemId(item)" 
							/>
                    </div>
                </template>

                <!-- Batch = Charge -->
                <template v-slot:[`item.batch`]="{ item, index }">
                    <div :alvqa="alvqa + '-list-row-' + index + '-text-batch'" class="ellipsis">
                         {{ $t(getLangOfBatch(item.batch)) }}
                    </div>
                </template>

                <!-- Quantity with number Integer formatting -->
                <!-- Nach item "index" hinzufügen um durch den Array loopen zu können -->
                
                <template v-slot:[`item.quantity`]="{ item, index }">
                    <div :alvqa="alvqa + '-list-row-' + index + '-text-quantity'" class="ellipsis">
                        {{ $n(item.quantity, 'numberInteger') }}
                    </div>
                </template>
                <template  v-slot:[`item.inventories`]="{ item, index }">
                     <div :alvqa="alvqa + '-list-row-' + index + '-text-price'" class="ellipsis">
                         <v-chip>
                            {{
                                $t('lang_ERP_SHIPPING_ITEMS_TOOLTIP_AVAILABILITY_TEXT') + ' ' + getPreviewQuantity(item) + ' | ' + 
                                $t('lang_ERP_SHIPPING_ITEMS_TOOLTIP_MIN_STOCK_TEXT') + ' ' + getPreviewMinQuantity(item)
                            }}
                         </v-chip>

                     </div>
                </template>

                <!-- Price = Einzelpreis netto -->
                <template v-slot:[`item.price`]="{ item, index }">
                     <div :alvqa="alvqa + '-list-row-' + index + '-text-price'" class="ellipsis">
                        <i18n-n v-if="item.price != null" :value="$alvPlugin.stringToNumber(item.price)" format="number"></i18n-n>
                     </div>
                </template>


                <!-- 
                    
                <template v-slot:[`item.batch`]="{ item }">
                    {{ $t(getLangOfBatch(item.batch)) }}
                </template>  

                QUANTITY ?

                <template v-slot:[`item.price`]="{ item }">
                    <i18n-n v-if="item.price != null" :value="$alvPlugin.stringToNumber(item.price)" format="number"></i18n-n>
                </template>

                <template v-slot:[`item.sum`]="{ item }">
                    <i18n-n v-if="item.sum != null" :value="$alvPlugin.stringToNumber(autocalculateSum(item))" format="number"></i18n-n>
                </template>

                <template v-slot:[`item.vat`]="{ item }">
                    <i18n-n v-if="item.vat != null" :value="$alvPlugin.stringToNumber(item.vat)" format="number"></i18n-n>
                </template>

                -->

                <!-- Row Button: DELETE  -->
                <template v-slot:[`item.delete`]="{ item, index }">
                    <BaseIcon 
                        @click="deleteShippingRows(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-' + index + '-icon-delete'"
                    />
                </template>

                <!-- Row Button: EDIT -->
                <template v-slot:[`item.inlineEdit`]="{ item, index }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-' + index + '-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template> -->
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseInlineEditingDataTable from "@/components/_base/BaseInlineEditingDataTable"
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'

import { DropdownErpShippingBatches } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ShippingRowsEditPanel",  
    components: { 
        BasePanel,
        BaseIcon,
        BaseInlineEditingDataTable,
        BaseButton,
        BaseTooltip
    },
    data() {
        return {
            alvqa: 'erp-shipping-edit-form-panel-shipping-rows',
            inventoryRows:null
        }
    },
    computed: {
        items() { 
            return this.$store.getters.getShippingShippingRows 
        },
		/** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, value: string}]} props of the header */
        headers() {
            let headers = [
                {   text: this.$t('lang_GENERIC_CAPTION_ITEM_TITLE'), 
                    alvqa: this.alvqa + "header-item-title",
                    align: "left", 
                    sortable: false, 
                    value: "connectionObject", 
                    tooltip: "", 
                    class: 'text-no-wrap',
                    width: "190px"
                },

                {   text: this.$t('lang_GENERIC_CAPTION_ID'), 
                    alvqa: this.alvqa + "header-item-id",
                    align: "left", 
                    sortable: false, 
                    value: "productId", 
                    tooltip: "", 
                    class: 'text-no-wrap',
                    width: "200px"},

                {   text: this.$t('lang_ERP_SHIPPING_CAPTION_BATCH'), 
                    alvqa: this.alvqa + "header-batch",
                    align: "left", 
                    sortable: false, 
                    value: "batch", 
                    tooltip:"", 
                    width: "140px"},

                {   text: this.$t('lang_ERP_INVOICES_CAPTION_QUANTITY'), 
                    alvqa: this.alvqa + "header-quantity",
                    align: "right",
                    sortable: false,
                    value: "quantity",
                    tooltip:"",
                    width: "140px"
                },
                {   text: this.$t('lang_ERP_INVOICES_CAPTION_ITEM_PRICE') + ' ' + this.$store.getters.getSelectedCurrency,
                    alvqa: this.alvqa + "header-item-price",
                    align: "right",
                    sortable: false,
                    value: "price",
                    tooltip:"",
                    width: "150px"
                },

                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }

            ]
            let inventoriesHeader = {
                    text: "",
                    alvqa: this.alvqa + "header-inventories",
                    align: "left",
                    sortable: false,
                    value: "inventories",
                    tooltip:"",
                    width:'200px'
            }
           this.showInventories && headers.splice(4,0,inventoriesHeader)

            return headers
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        showImportExcelButton() {
            let isLabelCompanySelected = this.$store.getters.getSelectedOverAllCompany.context === 2
            let isShippingSaved = this.$store.getters.getShippingDetailsAlvId !== 'ALV000000000SD'

            return isLabelCompanySelected && isShippingSaved
        },
        showInventories: {
            get() { return this.$store.getters.getShowShippingInventoriesPreview },
            set(show) { this.$store.commit('setShowShippingInventoriesPreview', show) }
        },
        invokeSaveCallForShowInventories: {
            get() { return this.$store.getters.getInvokeSaveCallForShippingInventories },
            set(value) { this.$store.commit('setInvokeSaveCallForShippingInventories', value) }
        },
        disableShowInventoriesBtn: {
            get() { return this.$store.getters.getDisableShowInventoriesButton },
            set(value) { this.$store.commit('setDisableShowInventoriesButton', value) }
        },
    },
    methods: {
        // autocalculateSum(item) {
        //     item.sum = this.$alvPlugin.stringToNumber(item.price) * this.$alvPlugin.stringToNumber(item.quantity)
        //     return item.sum
        // },
        addNewRow(){
            let companyType = this.$store.getters.getSelectedOverAllCompany.context
            // only releases or freetext for Shipping documents (not like Invoices)
            let searchType  = companyType == 2 ? "label/releases" : "publishing/releases"
            this.$store.commit('setShippingShippingRowsTitleSearch', searchType)
            this.$store.commit('setShippingShippingRowsIsNewSearch', true) // adding a new row
            this.$store.commit('setShippingShippingRowsTitleOptions', [])
            this.$store.commit('setShowEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))
            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultShippingShippingRows)) 
            this.$store.commit('setShippingShippingRowsEditingDialogDetails', defaultValues)
            this.showInventories = false
            this.invokeSaveCallForShowInventories = false
        }, 
        getLangOfBatch(selection) {
            if (selection) {
                return DropdownErpShippingBatches.find(obj => {
                    return obj.value == selection
                }).text
            } else return ""
        },
        async fetchInventories(){
            this.invokeSaveCallForShowInventories = !this.invokeSaveCallForShowInventories
            this.disableShowInventoriesBtn = true

            if(this.invokeSaveCallForShowInventories) {
                await this.$store.dispatch('saveShippingForm')
            }

            this.disableShowInventoriesBtn = false
            this.showInventories = !this.showInventories
        },
        hideInventories(){
            this.showInventories = false
            this.invokeSaveCallForShowInventories = false
        },
        getPreviewQuantity(item) {
            if(item.hasOwnProperty('previewQuantity')) {
                return item.previewQuantity !== null && item.previewQuantity !== undefined ? item.previewQuantity : this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            } else {
                return 0
            }
        },
        getPreviewMinQuantity(item) {
            if(item.hasOwnProperty('previewMinQuantity')) {
                // if(item.previewQuantity !== null && item.previewQuantity !== undefined) return item.previewQuantity
                // else return this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
                return item.previewMinQuantity !== null && item.previewMinQuantity !== undefined ? item.previewMinQuantity : this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            } else {
                return 0
            }
        },
        deleteShippingRows(item){ 
            // set the selected share/row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit("setSelectedShippingShippingRows", [item.id])
            this.$store.commit('setShowDeletionDialog', true)
            this.showInventories = false
            this.invokeSaveCallForShowInventories = false
        },
        editInlineFunction(item) {
            this.$store.commit('setSelectedShippingShippingRows', item.id)
            this.$store.commit('setShippingShippingRowsIsNewSearch', false) // editing an existing shipping row
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))
            // formatting numbers to show in correct notation, with comma or dot => $n()
            // also: we need to check whether they are null, because $n() cannot handle "null" => converts to 0,00
            
            if (detailsDeepCopy['price'] != null) 
                detailsDeepCopy['price'] = this.$n(this.$alvPlugin.stringToNumber(detailsDeepCopy['price']), 'number')

            // Backend returns search type such as "label/releases" as type for each shipping row
            this.$store.commit('setShippingShippingRowsTitleSearch', item.type)
            this.$store.commit('setShippingShippingRowsTitleOptions', [detailsDeepCopy])
            this.$store.commit('setShippingShippingRowsEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowEditingDialog', true) 
            this.showInventories = false
            this.invokeSaveCallForShowInventories = false
        },

        // Import
        importExcel() {
            this.$store.commit('setSelectedFileImport', 'shippingRows')
            this.$store.dispatch('doFileImport')
        },
    }
}
</script>

<style>
  .baseInlineEditingDataTable table {
    table-layout: fixed;
  }
  .baseInlineEditingDataTable table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>